// extracted by mini-css-extract-plugin
export default {"errorWrapper":"HKvXinMSU--7QDRUKdSpwQ==","errorTitle":"ZF3X87KlF3GikhKW0MSvig==","errorCode":"LOie7UhjF7AM5ZCj104Bqw=="};